import { Grid, Box, Typography } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { Close, CreditCard } from "@material-ui/icons";
import RegularButton from "components/CustomButtons/Button";
import { animations } from "helpers/animations";
import { blue, green, red } from "@material-ui/core/colors";

export const CustomerCreditConditionsViewAlert = ({ setCreditStatusAlert }) => {
  const { customer } = useSelector(({ customersReducer }) => customersReducer);
  const val = 500
  return (
    <Grid
      item
      xs={12}
      className={animations.fadeRight}
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 8,
        backgroundColor: `${
          customer.isCredit === 0
            ? blue[val]
            : customer.isCreditSuspended === 0
            ? green[val]
            : red[val]
        }`,
        color: "#f6f6f6",
        borderRadius: 8
      }}
    >
      <Typography>
        {customer.isCredit === 0
          ? "CLIENTE NO CUENTA CON CREDITO ACTIVO"
          : customer.isCreditSuspended === 0
          ? "CLIENTE CUENTA CON CREDITO ACTIVO"
          : "CLIENTE TIENE CREDITO SUSPENDIDO"}
      </Typography>

      <CreditCard style={{ margin: 0, fontSize: 60 }} />

      <RegularButton
        justIcon
        round
        color="transparent"
        onClick={() => setCreditStatusAlert(false)}
        style={{ 
          position: "absolute",
          top: 5,
          right: 10
         }}
      >
        <Close style={{ margin: 0 }} />
      </RegularButton>
    </Grid>
  );
};
